// extracted by mini-css-extract-plugin
export default {"loadingIcon":"OqfYAddBkMdM4Xc9cvDh","spinHolder":"VWnoiucdytD2V2996ww0","title":"DMFY9BqK8HZaVuZTHGpW","text":"eYx9uhGfkgCNfet50ZsR"};